module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistics_3"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("机构列表")]), _vm._v(" "), _c('div', {
    staticClass: "timeArea"
  }, [_c('el-select', {
    staticClass: "labSelect",
    attrs: {
      "size": "small",
      "placeholder": "数据库筛选"
    },
    on: {
      "change": _vm.getTab
    },
    model: {
      value: (_vm.params.code),
      callback: function($$v) {
        _vm.$set(_vm.params, "code", $$v)
      },
      expression: "params.code"
    }
  }, _vm._l((_vm.lbSet), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "timeArea inpArea"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "suffix-icon": "el-icon-search",
      "placeholder": "机构名称"
    },
    on: {
      "change": _vm.fancs
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "机构名称",
      "width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.classTrans(scope.row.code)
        }), _c('span', [_vm._v(_vm._s(_vm._f("transCode")(scope.row.code, 1)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "width": "270",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "dfGroup"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goAnlysis(scope.row, 1)
            }
          }
        }, [_vm._v("流量分析")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goAnlysis(scope.row, 2)
            }
          }
        }, [_vm._v("播放统计")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goAnlysis(scope.row, 3)
            }
          }
        }, [_vm._v("检索统计")])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-2c61f7a4"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/schoolTab.vue
// module id = 1440
// module chunks = 1